export default {
  USER_ID: "user_1s8Jx16sWB2djLHeed4yw",
  TEMPLATE_ID: "template_oc6ugfi",
};
